import { FlowConsumerContextEnergy as FlowContext } from '../../context';
import { EnergyType } from '../../shared/types';

export const shouldSkipWhenOnlyGeothermalHeating = (context: FlowContext): boolean => {
  const { energyType } = context;

  return energyType === EnergyType.GeothermalHeating;
};
